module.exports = __webpack_public_path__ + "static/media/OnAir.1f752ac8.jpg";